import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { DropDownComponentBase } from './drop-down.base.component';

import { StoreService } from '../../_services';
import { IBrand } from '../../_entities';

@Component({
    selector: 'corporate-brand-dropdown',
    template: require('./dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class CorporateBrandDropDownComponent extends DropDownComponentBase<IBrand> {
    constructor(private storeService: StoreService) {
        super();
    }

    getItems(): Promise<IBrand[]> {
        return this.storeService.getBrands();
    }
    mapItem(items: IBrand[], item: IBrand): IBrand {
        return items.find(x => x.code === item.code);
    }
    onItemSelected(item: IBrand) {
        this.selectedItemChange.emit(item);
    }

    @Input("selectedBrand") set selectedBinding(val: IBrand) {
        if (val != this.selectedItem)
            this.setSelectedItem(val);
    }
    @Output("selectedBrandChange") selectedItemChange = new EventEmitter<IBrand>();
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/corporate-brand-dropdown.component.ts